const View = require('public_framework/view')
const loadHighlight = require('bundle-loader?lazy!highlight.js')
const loadHighlightStyles = require('bundle?lazy!highlight.js/styles/solarized-light.css')

export default class Code extends View {
  constructor () {
    super(...arguments)
    const code = this.el.querySelector('code')
    loadHighlight((hljs) => hljs.highlightBlock(code))
    loadHighlightStyles(() => {})
  }
}



// WEBPACK FOOTER //
// ./front/apps/public/pages/sorting_algorithms/javascripts/views/code.js